import type { DefaultTheme } from 'styled-components';

/**
 * Shared style helpers for un-bulk-upload (PRD §5), tuned to match the live
 * sandbox pixel-for-pixel. Colours read from the injected theme via
 * `tok(theme, token, fallback)`; tenant-specific accents (the UN blue used for
 * the instruction/summary icons) are constants.
 */

/** Theme token lookup with a fallback. */
export const tok = (theme: DefaultTheme | undefined, name: string, fallback: string): string => {
  const v = theme?.colors?.[name];
  return typeof v === 'string' ? v : fallback;
};

/** Carousel / grid breakpoint. */
export const MOBILE = '880px';

/** UN tenant accent used for the instruction + total-records icons (#009EDB). */
export const UN_BLUE = '#009EDB';
